import { useSharedComponentsTranslate } from '@vcc-www/shared-dictionaries';
import type { ReactNode } from 'react';

type HeaderProps = {
  name: ReactNode;
  distance?: string;
  id?: string;
};
export const Header = ({ name, distance, id }: HeaderProps) => {
  const translate = useSharedComponentsTranslate();
  return (
    <div className="flex-row justify-between font-medium" id={id}>
      {name}
      {distance && (
        <p
          aria-label={translate(
            'RetailerSelector.retailerCard.distanceAriaLabel',
            {
              distance,
            },
          )}
          className="min-w-fit"
        >
          {distance}
        </p>
      )}
    </div>
  );
};
